export const EXPANDABLE_LIST_ITEM_CLASS = "expandable-list-item";
export const MIN_DESKTOP_WIDTH = "600px";
export const CONTENT_MARGIN_TOP_DESKTOP = "64px";
export const CONTENT_MARGIN_TOP_MOBILE = "56px";
